import { Body, Form, Spacer } from '@spritz-finance/ui'
import { TokenBalance } from '../../../../graphql/generated/graphql'
import { useDirectPayContext } from './context/DirectPayContext'
import { FormItemHeader } from './form/CreateDirectPaymentForm'
import { TokenListItem } from './TokenListItem'

export const TokenSelect = ({ disabled }: { disabled?: boolean }) => {
    const { tokenBalances } = useDirectPayContext()
    return (
        <>
            <FormItemHeader>
                <Body.Med secondary size={12}>
                    Pay with
                </Body.Med>
                <Body.Med secondary size={12}>
                    Available balance
                </Body.Med>
            </FormItemHeader>
            <Spacer height={4} />
            <Form.Select<TokenBalance>
                name="tokenAddress"
                disabled={disabled}
                validationMessage="Please select the token you would like to pay with"
                validation={{
                    required: true,
                }}
                options={tokenBalances}
                optionValue={(option) => option.address}
                renderItem={(option) => <TokenListItem token={option} />}
                renderLabel={(option) => option.symbol}
                overrideLabel
            />
        </>
    )
}
